import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const LoadingLabel = styled.span`
	padding-left: 2px;
	color: ${helpers.color.input.contentLoading};
	align-self: center;
`
